import React, { useEffect, useState } from 'react'
import { Button, Card, Modal, Spinner } from 'react-bootstrap'
import './customerDashboard.scss'

import customerDashboardOne from '../../../media/images/customerDashboardOne.jpeg';
import customerDashboardTwo from '../../../media/images/customerDashboardTwo.jpeg';
import customerDashboardThree from '../../../media/images/customerDashboardThree.jpeg';
import customerDashboardFour from '../../../media/images/customerDashboardFour.jpeg';
import PrimaryButton from '../../../jsx/components/button/primaryButton';
import { useNavigate } from 'react-router-dom';
import { btnCreateAServiceRequest, txtHomeIntroCustomer } from '../../../dataBaseFile/label';
import helpCenterImg from '../../../media/images/helpCenterImg.png';
import { useDispatch, useSelector } from 'react-redux';
import { getPaymentConfigApi } from '../../../service/api/paymentGateway/getPaymentConfig';
import { getCounterApi } from '../../../service/api/ticket/serviceCounters';
import SkeletonDivElement from '../../../component/skeletonTableRow/skeletonDivElement';
import connectToProImage from '../../../media/images/customerDashboardAssets/connectToProImage.jpeg'
import homeCheckupImage from '../../../media/images/customerDashboardAssets/homeCheckupImage.jpeg'
import CreateDIYimage from '../../../media/images/customerDashboardAssets/CreateDIYimage.jpeg'
import videoIcon from '../../../media/images/shortLogo.ico'
import { setIsSignUpFlagFalse } from '../../../feature/userData/userData';
import logo from "../../../icons/photos/chillLogo.png";
import customerDashboardImg from '../../../media/images/customerDashboardAssets/customerDashboardImg.jpeg'
import appleQRcodeImg from '../../../media/images/customerDashboardAssets/appleQRcodeImg.jpeg'
import androidQRcodeImg from '../../../media/images/customerDashboardAssets/androidQRcodeImg.jpeg'
import splashImg from "../../../media/images/authAssets/splashImg.jpeg";
import heroCustomerDashboardImg from '../../../media/images/customerDashboardAssets/heroCustomerDashboardImg.png'
import { RiVipCrownFill } from 'react-icons/ri';

const CustomerDashboard = () => {
    const { isSignUpFlag, totalCreditsInCents, userName } = useSelector((state) => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [callDurationTimeLimit, setCallDurationTimeLimit] = useState(0);
    const [callChargeAmount, setCallChargeAmount] = useState(0);
    const [paymentConfigLoading, setPaymentConfigLoading] = useState(false);
    const [lastServiceRequest, setLastServiceRequest] = useState({});
    const [lastProject, setLastProject] = useState({});
    const [lastActivityLoading, setLastActivityLoading] = useState(false);

    const [toggleForCustomerDashboard, setToggleForCustomerDashboard] = useState(isSignUpFlag);

    const [loginForMobileView, setLoginForMobileView] = useState(
        window.innerWidth < 768 ? true : false
    );

    const [freeCreditsModal, setFreeCreditsModal] = useState(true);
    const [serviceSummaryMetaData, setServiceSummaryMetaData] = useState({});

    const [confirmEstimationsModalTrigger, setConfirmEstimationsModalTrigger] = useState(false);

    useEffect(() => {
        setToggleForCustomerDashboard(isSignUpFlag)
    }, [isSignUpFlag])

    const getPaymentConfigFn = () => {
        let details = {};
        setPaymentConfigLoading(true)
        dispatch(
            getPaymentConfigApi(
                details,
                (res) => {
                    // console.log(res.data.data)
                    // console.log(res?.data?.data)
                    //   setPaymentGatewayFlag(
                    //     res?.data?.data?.purchase?.payment_gateway_flag
                    //   );
                    setPaymentConfigLoading(false)
                    setCallChargeAmount(
                        res?.data?.data?.purchase?.call_charge_amount_in_cents_int / 100
                    );
                    setCallDurationTimeLimit(
                        res?.data?.data?.purchase?.call_duration_time_limit_in_sec / 60
                    );
                    //   setCallChargeDescription(
                    //     res?.data?.data?.purchase?.call_charge_description_chr
                    //   );
                },
                (res) => {
                    // console.log(res.data.data);
                    setPaymentConfigLoading(false)
                }
            )
        );
    };

    // console.log(paymentGatewayFlag, 'paymentGatewayFlag', callChargeAmount, '$ callChargeAmount', callDurationTimeLimit, 'min callDurationTimeLimit')

    useEffect(() => {
        getPaymentConfigFn();
    }, []);

    const handleCreateRequest = () => {
        navigate('/scanNew');
    }

    let USDollar = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    // Active call option
    const [activeCalls, setActiveCalls] = useState([]);

    const getCountersData = () => {
        let details = {
            scheduled_tickets_flag: 2,
        };
        setLastActivityLoading(true);
        dispatch(
            getCounterApi(
                details,
                (res) => {
                    setActiveCalls(res.data.active_calls);

                    const { last_service_request, last_project } = res.data;

                    // Modified logic for showing the last check-in by pro always

                    setLastServiceRequest(last_service_request);

                    // if (!last_service_request && !last_project) {
                    //     setLastServiceRequest({});
                    //     setLastProject({});
                    // } else if (!last_service_request) {
                    //     setLastProject(last_project);
                    // } else if (!last_project) {
                    //     setLastServiceRequest(last_service_request);
                    // } else {
                    //     if (last_service_request.created_date_dtm > last_project.created_date_dtm) {
                    //         setLastServiceRequest(last_service_request);
                    //         setLastProject({});
                    //     } else {
                    //         setLastProject(last_project);
                    //         setLastServiceRequest({});
                    //     }
                    // }
                    setLastActivityLoading(false);
                },
                () => {
                    setLastActivityLoading(false);
                }
            )
        );
    }

    useEffect(() => {
        getCountersData();
    }, [localStorage.getItem("updateCustomerDashboard")]);

    useEffect(() => {
        if (Object.keys(lastServiceRequest).length > 0) {
            if (lastServiceRequest?.summary_meta_data) {

                // debugger;
                // const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
                // const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

                const finalObjectTwo = (JSON.parse(lastServiceRequest?.summary_meta_data));

                let finalObject = {};

                // if(!Object.keys(finalObjectTwo).length > 0) {
                if (typeof (finalObjectTwo) === 'string') {
                    finalObject = JSON.parse(finalObjectTwo);
                }

                // console.log(finalObject, "finalObject");
                // console.log(finalObjectTwo, "finalObjectTwo");

                if (Object.keys(finalObject).length > 0) {
                    setServiceSummaryMetaData(finalObject);
                } else if (Object.keys(finalObjectTwo).length > 0) {
                    setServiceSummaryMetaData(finalObjectTwo);
                } else {
                    setServiceSummaryMetaData({});
                }

            }
        }
    }, [lastProject, lastServiceRequest])

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    useEffect(() => {
        if (localStorage.getItem("isEstimateService") == 1) {
            localStorage.setItem('serviceDetailsTab', 6);
            navigate("/serviceRequestDetails");
        }
        return () => {
            dispatch(setIsSignUpFlagFalse())
        }
    }, [])

    useEffect(() => {
        // console.log('sumary meta data', serviceSummaryMetaData);

    }, [serviceSummaryMetaData])

    return (
        <>
            <div
                className=' d-flex justify-content-center align-items-center p-4 h-100'
                style={{
                    // width: '98%',
                    // height: '',
                    // display: 'flex',
                    // justifyContent: 'center',
                    // alignItems: 'center',
                    // flexDirection: 'column',
                    // padding: '20px'
                    background: 'linear-gradient(182deg,rgba(250, 238, 227, 1) 33%, rgba(255, 255, 255, 1) 85%)',
                }}
            >
                <div className='customer-dashboard-main-container' style={{ margin: 'auto', }}>

                    {toggleForCustomerDashboard && !loginForMobileView ?
                        <>
                            <div className='row mx-0'>
                                <div className='col-12 rounded-2 mb-3'
                                    style={{
                                        // boxShadow: '0px 0px 7px gray'
                                    }}
                                >
                                    <div className='row mx-0 mb-4'>
                                        <div className='col-lg-8 col-sm-6 col-md-6 pe-2 pe-sm-0 mt-2'>
                                            <div className='d-flex  flex-column justify-content-between h-100'>
                                                <div className='mb-3'>
                                                    <span className='fw-bold fs-3 text-black'>{`Welcome ${userName?.split(" ", 1)}!`}</span>
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <span className='fs-4'><strong>{`Chilll works best on your smart device.`}</strong></span>
                                                    <span className='fs-4'><strong>{`Scan a QR code`}</strong></span>
                                                </div>
                                                <div></div>
                                            </div>
                                        </div>

                                        <div className='col-lg-4 col-sm-6 col-md-6 d-flex align-items-center ps-2 ps-sm-0 mt-2'>
                                            <img src={customerDashboardImg} alt="" style={{ width: '100%', height: '170px', objectFit: 'contain' }} />
                                        </div>
                                    </div>

                                    {/* <div className='d-flex justify-content-center align-items-center py-2'>
                                        <div style={{ width: '100%', height: '2px', background: '#16BA4E' }}></div>
                                    </div> */}

                                    <div className='row mx-0 mb-4'>
                                        <div className='col-6 mt-2'>
                                            <div className='d-flex flex-column justify-content-between align-items-center h-100'>
                                                <img className='shadow' src={appleQRcodeImg} alt="" style={{ width: '140px', height: '140px', objectFit: 'fill', border: '2px solid black' }} />

                                                <div className='d-flex justify-content-center align-items-center mt-3 fs-4 text-black font-w600'>
                                                    <span className='me-2'><i className='bi bi-apple' /></span>
                                                    <span>{`Apple / IOS App`}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-6  mt-2'>
                                            <div className='d-flex flex-column justify-content-between align-items-center h-100'>
                                                <img className='shadow' src={androidQRcodeImg} alt="" style={{ width: '140px', height: '140px', objectFit: 'fill', border: '2px solid black' }} />

                                                <div className='d-flex justify-content-center align-items-center mt-3 fs-4 text-black font-w600'>
                                                    <span className='me-2'><i className='bi bi-google-play' /></span>
                                                    <span>{`Android App`}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='row mx-0 mb-2 mt-5 '>
                                        <div className='col-12 d-flex justify-content-center align-items-center'>
                                            <span
                                                className='fs-4 cursor-pointer text-hovered text-decoration-underline'
                                                onClick={() => {
                                                    setToggleForCustomerDashboard(false);
                                                    dispatch(setIsSignUpFlagFalse());
                                                }}
                                            >
                                                {`I'll do that later`}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className='row mx-0 mb-4'>

                                <div className='col-12 d-flex justify-content-center align-items-center '>
                                    <img src={logo} alt="" style={{ width: '120px', height: '80px', objectFit: 'contain' }} />
                                </div>

                                <div className='col-12 d-flex justify-content-center align-items-center mb-4'>
                                    <img src={heroCustomerDashboardImg} alt='' style={{ width: '280px', height: '200px', objectFit: 'contain' }} />
                                </div>

                                <div className='col-12 d-flex justify-content-center align-items-center mb-4'>
                                    <span className='text-black fs-4 text-center'>Connect To A Remote Pro & Get Expert Help For
                                        <span className='font-w600'> Free!</span>
                                    </span>
                                </div>

                                <div className='col-12 d-flex justify-content-center align-items-center mb-4'>
                                    {/* <PrimaryButton
                                        onClick={() => {
                                            handleCreateRequest();
                                        }}
                                        buttonName={"CONNECT TO A PRO"}
                                        style={{
                                            width: '230px',
                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                            border: '2px solid rgba(255, 154, 32, 1)',
                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                        }}
                                    /> */}
                                    <Button
                                        className='d-flex justify-content-center align-items-center'
                                        onClick={() => {
                                            handleCreateRequest();
                                        }}
                                        style={{
                                            width: '230px',
                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                            border: '2px solid rgba(255, 154, 32, 1)',
                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                        }}
                                    >
                                        <RiVipCrownFill
                                            className='me-2'
                                            style={{
                                                color: 'white',
                                                fontSize: '20px',
                                            }}
                                        />
                                        <span>{"CONNECT NOW"}</span>
                                    </Button>
                                </div>

                                <div
                                    className={`col-12 d-flex justify-content-center align-items-center mb-4 flex-column py-4 px-2 rounded-2 ${((Object.keys(lastServiceRequest).length > 0) && (lastServiceRequest?.ticket_status_ysn == 2 || lastServiceRequest?.ticket_status_ysn == 5) && lastServiceRequest?.ticket_type_int != 0) || (lastServiceRequest?.ticket_status_ysn == 1 && lastServiceRequest?.ticket_type_int != 0) ? 'bg-white shadow' : ''} `}
                                >
                                    {lastActivityLoading ?
                                        <div className='d-flex justify-content-center'>
                                            <Spinner animation="border" variant="primary" />
                                        </div>
                                        :
                                        <>
                                            {(Object.keys(lastServiceRequest).length > 0) && (lastServiceRequest?.ticket_status_ysn == 2 || lastServiceRequest?.ticket_status_ysn == 5) && lastServiceRequest?.ticket_type_int != 0 ?
                                                <>
                                                    <span className='font-w600 text-primary mb-3'>
                                                        {`${lastServiceRequest?.created_date_dtm ?
                                                            // formatUnixTimestamp(lastServiceRequest?.created_date_dtm) 
                                                            new Intl.DateTimeFormat("en-US", {
                                                                year: "numeric",
                                                                month: "short",
                                                                day: "numeric",
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                hour12: true
                                                            }).format(
                                                                lastServiceRequest?.created_date_dtm * 1000
                                                            )
                                                            :
                                                            ''}`
                                                        }
                                                    </span>
                                                    <span
                                                        className=' text-center font-w500 terms-condition-link text-decoration-underline'
                                                        style={{
                                                            color: '#0000ffd1'
                                                        }}
                                                        onClick={() => {
                                                            if (!serviceSummaryMetaData?.pro_check_info?.pro_diagnosis && !serviceSummaryMetaData?.pro_check_info?.pro_recommended_solution) {
                                                                setConfirmEstimationsModalTrigger(true);
                                                            } else {
                                                                localStorage.setItem("ticket_id", lastServiceRequest?.ticket_id_ids);
                                                                localStorage.setItem("ticket_display_name", lastServiceRequest?.display_id_int);
                                                                localStorage.setItem('serviceDetailsTab', 6);
                                                                navigate("/serviceRequestDetails");
                                                            }
                                                        }}
                                                    >
                                                        {/* {(!serviceSummaryMetaData?.pro_check_info?.pro_diagnosis && !serviceSummaryMetaData?.pro_check_info?.pro_recommended_solution) && serviceSummaryMetaData?.pro_check_info?.pro_recommended_solution == 3 ?
                                                            `We are looking the Local Pro for your ${lastServiceRequest?.category_name_chr} project.` :
                                                            `Your ${lastServiceRequest?.category_name_chr} report is now ready`
                                                        } */}
                                                        {(!serviceSummaryMetaData?.pro_check_info?.pro_diagnosis && !serviceSummaryMetaData?.pro_check_info?.pro_recommended_solution) ?
                                                            // `Please wait, the Pro is preparing the estimation report for your ${lastServiceRequest?.category_name_chr} project.` 
                                                            `Waiting for Estimate to be Completed by Pro.` :
                                                            (serviceSummaryMetaData?.pro_check_info?.pro_diagnosis && serviceSummaryMetaData?.pro_check_info?.pro_recommended_solution) ?
                                                                <>
                                                                    {
                                                                        (serviceSummaryMetaData?.customer_check_info?.customer_selected_solution == 1) ?
                                                                            `Your ${lastServiceRequest?.category_name_chr} report is now ready` :
                                                                            (serviceSummaryMetaData?.customer_check_info?.customer_selected_solution == 3
                                                                                && serviceSummaryMetaData?.is_recommendation_updated_by_cust == 0
                                                                            ) ?
                                                                                `Your ${lastServiceRequest?.category_name_chr} report is now ready` :
                                                                                (serviceSummaryMetaData?.customer_check_info?.customer_selected_solution == 3
                                                                                    && serviceSummaryMetaData?.is_recommendation_updated_by_cust == 1
                                                                                )
                                                                                    ?
                                                                                    // `We are looking the Local Pro for your ${lastServiceRequest?.category_name_chr} project.`
                                                                                    `Waiting for Local Pro to come to my Home` :
                                                                                    (serviceSummaryMetaData?.customer_check_info?.customer_selected_solution == 2
                                                                                        && !serviceSummaryMetaData?.is_recommendation_updated_by_cust
                                                                                    )
                                                                                        ?
                                                                                        `Your ${lastServiceRequest?.category_name_chr} report is now ready` :
                                                                                        (serviceSummaryMetaData?.customer_check_info?.customer_selected_solution == 2
                                                                                            && serviceSummaryMetaData?.is_recommendation_updated_by_cust == 1
                                                                                        )
                                                                                            ?
                                                                                            // `We are looking the Local Pro for your ${lastServiceRequest?.category_name_chr} project.`
                                                                                            `Waiting for a Remote Pro to connect to fix my Problem` :

                                                                                            (serviceSummaryMetaData?.pro_check_info?.pro_recommended_solution == 1 || serviceSummaryMetaData?.pro_check_info?.pro_recommended_solution == 2) ?
                                                                                                `Your ${lastServiceRequest?.category_name_chr} report is now ready` :
                                                                                                (serviceSummaryMetaData?.pro_check_info?.pro_recommended_solution == 3) ?
                                                                                                    serviceSummaryMetaData?.is_recommendation_updated_by_cust == 0 ?
                                                                                                        `Your ${lastServiceRequest?.category_name_chr} report is now ready` :
                                                                                                        serviceSummaryMetaData?.is_recommendation_updated_by_cust == 1 ?
                                                                                                            `We are looking the Local Pro for your ${lastServiceRequest?.category_name_chr} project.` : `` : ``
                                                                    }
                                                                </> : <></>


                                                        }
                                                    </span>

                                                </> :
                                                <>
                                                    {lastServiceRequest?.ticket_status_ysn == 1 && lastServiceRequest?.ticket_type_int != 0 &&
                                                        <>
                                                            <span className='font-w600 text-primary'>
                                                                {`${lastServiceRequest?.created_date_dtm ? formatUnixTimestamp(lastServiceRequest?.created_date_dtm) : '-'}`}
                                                            </span>
                                                            <span
                                                                className='text-center font-w500 terms-condition-link text-decoration-underline'
                                                                style={{
                                                                    color: '#0000ffd1'
                                                                }}
                                                                onClick={() => {
                                                                    setConfirmEstimationsModalTrigger(true);

                                                                    // localStorage.setItem("ticket_id", lastServiceRequest?.ticket_id_ids);
                                                                    // localStorage.setItem("ticket_display_name", lastServiceRequest?.display_id_int);
                                                                    // navigate("/serviceRequestDetails");
                                                                }}
                                                            >
                                                                {/* {`Waiting for a Pro for my ${lastServiceRequest?.category_name_chr} project.`} */}
                                                                {`Waiting for Remote Pro to connect to me for an Estimate.`}
                                                            </span>

                                                        </>
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                </div>
                            </div>

                            {false &&
                                <>
                                    <div className='row mx-0'>

                                        <div className='col-12 rounded-2 mb-3'
                                            style={{
                                                // boxShadow: '0px 0px 7px gray'
                                            }}
                                        >

                                            <div className='row mx-0 mb-4'>
                                                <div className='col-12 d-flex align-items-center'>
                                                    <div className='me-5'>
                                                        <img src={logo} alt="" style={{ width: '120px', height: '80px', objectFit: 'contain' }} />
                                                    </div>
                                                    <div className='text-primary fs-5'>
                                                        <span className='text-center'><strong>{`A.I. for your DIY`}</strong></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row mx-0 mb-2'>
                                                <div
                                                    className='col-12 d-flex align-items-center p-2 rounded-2 overlay-action-btn cursor-pointer bg-white'
                                                    style={{
                                                        border: '3px solid #16BA4E',
                                                        boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                    }}
                                                    onClick={() => {
                                                        navigate('/DIYproject');
                                                    }}
                                                >
                                                    <div className='me-4'>
                                                        <img src={CreateDIYimage} alt="" style={{ width: '70px', height: '60px', objectFit: 'contain' }} />
                                                    </div>
                                                    <div className='text-black fs-5'>
                                                        <span className='text-center font-w600'><strong>{`DIY Project Planner`}</strong></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row mx-0 mb-2'>
                                                <div
                                                    className='col-12 d-flex align-items-center p-2 rounded-2 overlay-action-btn cursor-pointer bg-white'
                                                    style={{
                                                        border: '3px solid #16BA4E',
                                                        boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                    }}
                                                    onClick={() => {
                                                        navigate('/maintenance');
                                                    }}
                                                >
                                                    <div className='me-4'>
                                                        <img src={homeCheckupImage} alt="" style={{ width: '70px', height: '60px', objectFit: 'contain' }} />
                                                    </div>
                                                    <div className='text-black fs-5'>
                                                        <span className='text-center font-w600'><strong>{`Smart DIY Home Inspection`}</strong></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row mx-0 mb-2'>
                                                <div
                                                    className='col-12 d-flex align-items-center p-2 rounded-2 overlay-action-btn cursor-pointer bg-white'
                                                    style={{
                                                        border: '3px solid #FF7401',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 116, 1, 0.24)'
                                                    }}
                                                    onClick={() => {
                                                        handleCreateRequest();
                                                    }}
                                                >
                                                    <div className='me-4'>
                                                        <img src={connectToProImage} alt="" style={{ width: '70px', height: '60px', objectFit: 'contain' }} />
                                                    </div>
                                                    <div className='text-black fs-5'>
                                                        <span className='text-center font-w600'><strong>{`Get Instant Help from a Remote Pro`}</strong></span>
                                                        <div>
                                                            {/* {!paymentConfigLoading && <span className='fs-6'>{`Only ${USDollar.format(
                                                parseFloat(callChargeAmount?.toFixed(2))
                                            )} for ${callDurationTimeLimit} minutes`}</span>} */}

                                                            {!paymentConfigLoading && <span className='fs-6'>{`Just $${callChargeAmount} for ${callDurationTimeLimit} minutes`}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='d-flex justify-content-center align-items-center pt-2'>
                                                <div style={{ width: '60%', height: '2px', background: '#16BA4E' }}></div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className='row mx-0 mb-4'>
                                        <div className='col-6 px-0 mt-2 pe-3 '>
                                            <div
                                                className={`'d-flex flex-column p-4 rounded-2 h-100 bg-white ${(Object.keys(lastServiceRequest).length > 0 || Object.keys(lastProject).length > 0) ? 'border-hovered cursor-pointer' : ''} `}
                                                style={{ boxShadow: '0px 0px 7px gray' }}
                                                onClick={() => {
                                                    if (Object.keys(lastServiceRequest).length > 0 || Object.keys(lastProject).length > 0) {
                                                        if (Object.keys(lastServiceRequest).length > 0) {
                                                            localStorage.setItem("ticket_id", lastServiceRequest?.ticket_id_ids);
                                                            localStorage.setItem("ticket_display_name", lastServiceRequest?.display_id_int);
                                                            navigate("/serviceRequestDetails");
                                                        } else if (Object.keys(lastProject).length > 0) {
                                                            localStorage.setItem("projectId", lastProject?.project_id_ids);
                                                            localStorage.setItem("DIYprojectStep", 3);
                                                            navigate('/DIYproject')
                                                        }
                                                    }
                                                }}
                                            >


                                                {lastActivityLoading ?
                                                    <>
                                                        <div className='d-flex justify-content-center'>
                                                            <SkeletonDivElement height={'28px'} width={'70%'} borderRadius={'4px'} marginBottom={'9px'} />
                                                        </div>

                                                        <div className='d-flex justify-content-center'>
                                                            <SkeletonDivElement height={'28px'} width={'70%'} borderRadius={'4px'} marginBottom={'9px'} />
                                                        </div>

                                                        <div className='d-flex justify-content-center'>
                                                            <SkeletonDivElement height={'28px'} width={'70%'} borderRadius={'4px'} marginBottom={'9px'} />
                                                        </div>

                                                    </> : <>

                                                        <div className='d-flex justify-content-center align-items-center mb-2'>
                                                            <span className='text-black font-w600 text-center'>
                                                                {Object.keys(lastProject).length > 0 ? `Last Project` : `Last Request`}
                                                            </span>
                                                        </div>

                                                        {(Object.keys(lastServiceRequest).length > 0 || Object.keys(lastProject).length > 0) ?
                                                            <>
                                                                <div className='d-flex justify-content-center align-items-center mb-2'>
                                                                    {Object.keys(lastServiceRequest).length > 0 ?
                                                                        <>
                                                                            {lastServiceRequest.category_name_chr !== ("" || null) ?
                                                                                <span
                                                                                    className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                                    style={{
                                                                                        background: "rgba(79, 93, 116, 1)",
                                                                                    }}>
                                                                                    {`${lastServiceRequest.category_name_chr} ${((lastServiceRequest.product_type_chr !== "null") && (lastServiceRequest.product_type_chr !== null) && (lastServiceRequest.product_type_chr !== "")) ? ` / ${lastServiceRequest.product_type_chr}` : ''}`}
                                                                                </span> :
                                                                                <span
                                                                                    className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                                    style={{
                                                                                        background: 'rgba(199, 212, 234, 1)'
                                                                                    }}>
                                                                                    {`No category`}
                                                                                </span>
                                                                            }
                                                                        </> : <span className='rounded-2 p-2 bg-light text-center'>
                                                                            {`${lastProject?.project_title_chr}`}
                                                                        </span>
                                                                    }
                                                                </div>

                                                                <div className='d-flex justify-content-center align-items-center mt-3'>
                                                                    {Object.keys(lastServiceRequest).length > 0 ?
                                                                        <span className=''>
                                                                            {`${lastServiceRequest?.created_date_dtm ? formatUnixTimestamp(lastServiceRequest?.created_date_dtm) : '-'}`}
                                                                        </span> :
                                                                        <span className=''>
                                                                            {`${lastProject?.created_date_dtm ? formatUnixTimestamp(lastProject?.created_date_dtm) : '-'}`}
                                                                        </span>
                                                                    }
                                                                </div>
                                                            </> :
                                                            <>
                                                                <div className='mt-4 d-flex align-items-center justify-content-center'>
                                                                    <span className='text-center font-w600'>
                                                                        {`No calls yet`}
                                                                    </span>
                                                                </div>
                                                            </>
                                                        }
                                                    </>}
                                            </div>
                                        </div>

                                        <div className='col-6 px-0 mt-2 ps-3 '>
                                            <div className='d-flex flex-column p-4 rounded-2 h-100 bg-white'
                                                style={{ boxShadow: '0px 0px 7px gray' }}
                                            >
                                                <div className='d-flex justify-content-center align-items-center'>
                                                    <span className='text-black font-w600 text-center mb-2'>{`Help Center`}</span>
                                                </div>

                                                <div className='d-flex justify-content-center align-items-center'>
                                                    <img
                                                        src={helpCenterImg}
                                                        alt=''
                                                        style={{ height: '80px', width: '80px' }}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </>}
                        </>
                    }

                </div>
            </div>

            <Modal
                className="fade"
                show={freeCreditsModal && isSignUpFlag && totalCreditsInCents}
                // onHide={handleClose}
                centered
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => {
                                            // dispatch(setIsSignUpFlagFalse());
                                            setFreeCreditsModal(false);
                                        }}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <i className='bi bi-check2-circle text-success' style={{ fontSize: '100px' }} />
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="text-center">{'Congratulations!'}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-2">
                                <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                    {/* <span className="fs-5 text-center">
                                        {"Measuring feature is avaible on mobile devices. Please download Chilll app from playstore or appstore to use this feature."}
                                    </span> */}

                                    <p className="fs-4 text-center font-w600">
                                        You have received <span className="font-w600 text-black">{`${USDollar.format(totalCreditsInCents / 100)}`}</span> free credits to use in Chilll services!
                                    </p>
                                </div>
                            </div>

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-12 font-w600 mb-2 d-flex justify-content-center">
                                    <PrimaryButton
                                        onClick={() => {
                                            // dispatch(setIsSignUpFlagFalse());
                                            setFreeCreditsModal(false);
                                        }}
                                        buttonName={"AWESOME"}
                                        style={{
                                            width: "auto",
                                            border: 'none',
                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={confirmEstimationsModalTrigger} centered>

                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                        <img src={logo} alt="" style={{ maxWidth: '125px' }} />
                                    </div>
                                </div>

                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-12 font-w600 fs-4 px-0 text-center'>
                                        <span>
                                            {'Please wait while the Pro reviews and accepts your estimate.'}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0'>
                                    <div className='col-6 pe-2 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                localStorage.setItem("ticket_id", lastServiceRequest?.ticket_id_ids);
                                                localStorage.setItem("ticket_display_name", lastServiceRequest?.display_id_int);
                                                localStorage.setItem('serviceDetailsTab', 6);
                                                navigate("/serviceRequestDetails");
                                                setConfirmEstimationsModalTrigger(false);
                                            }}
                                            buttonName={"OKAY"}
                                            type="submit"
                                            loadingMessage="SUBMITTING..."
                                            isLoading={false}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>

                                    <div className='col-6 ps-2 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                setConfirmEstimationsModalTrigger(false);
                                            }}
                                            buttonName={"CANCEL"}
                                            type="submit"
                                            loadingMessage="SUBMITTING..."
                                            isLoading={false}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CustomerDashboard;